import React, { useRef, useContext } from 'react';
import { useFetch } from 'use-http';
import Dialog from 'src/components/common/Dialog.redesign';
// import { TextInput } from 'src/components/controls/forms/reactHookForm';
import Button from 'src/components/controls/forms/redesign/FormButton';
import Audit from 'src/models/Audit';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';
import LandContractType from 'src/models/LandContractType';

interface IRevokeContractInhandDialogProps {
    contractType: LandContractType;
    entityName: string;
    commitListener: (data: boolean) => void;
    confirmRevokeInhand: () => void;
    cancelRevokeInhand: () => void;
}

const RevokeContractInhandDialog = (props: IRevokeContractInhandDialogProps) => {
    const inputRef = useRef(null);
    const { post, response } = useFetch();
    const appContext = useContext<IAppContextState>(AppContext);

    const clearInputField = async () => {
        if (inputRef.current.value === `Reason for revoking In-hand status` || inputRef.current.value === '' || inputRef.current.value === 'reason required') {
            inputRef.current.value = '';
        }
    };

    const confirmRevokeInhand = async (leaseNumber: string) => {
        const leaseNumberAsNumber = !isNaN(Number(leaseNumber)) ? Number(leaseNumber) : 0;
        let auditSucceeded = false;
        if (inputRef.current.value === `Reason for revoking In-hand status` || inputRef.current.value === '' || inputRef.current.value === 'reason required') {
            (inputRef.current as HTMLInputElement).focus();
            (inputRef.current as HTMLInputElement).style.color = 'red';
            (inputRef.current as HTMLInputElement).value = 'reason required';
            return;
        } else if (props.contractType === LandContractType.BrineLease) {
            let data: Audit = { transactionId: '',
                                type: 'U',
                                tableName: 'BrineLease',
                                pk: leaseNumberAsNumber,
                                fieldName: 'IsInHand',
                                oldValue: '1',
                                newValue: '0',
                                updateDate: new Date(),
                                reason: inputRef.current.value,
                                userId: Number(appContext.currentUser.userId)
                             };
            auditSucceeded = await AuditBrineLeaseChange(data);
        } else if (props.contractType === LandContractType.OilAndGas) {
            let data: Audit = { transactionId: '',
                                type: 'U',
                                tableName: 'Lease',
                                pk: leaseNumberAsNumber,
                                fieldName: 'IsInHand',
                                oldValue: '1',
                                newValue: '0',
                                updateDate: new Date(),
                                reason: inputRef.current.value,
                                userId: Number(appContext.currentUser.userId)
                             };
            auditSucceeded = await AuditOgLeaseChange(data);
        } else {
            // TODO: Set up similar audit log other project types.
            auditSucceeded = true;
        }

        if (!!auditSucceeded) {
            props.confirmRevokeInhand();
        }
        props.commitListener(true);
        props.cancelRevokeInhand();
    };

    const handleEdit = () => {
        (inputRef.current as HTMLInputElement).style.color = 'black';
    };

    const AuditBrineLeaseChange = async (data: Audit) => {
        let currentPath = window.location.pathname.split('/');
        currentPath.splice(currentPath.length - 3, 3);

        let result = await post(
            `/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/ownership/${appContext.ownerId}/BrineLease/audit`,
            data
        );
        if (response.ok) {
            console.log(result);
            return true;
        } else {
            window.alert('Audit Brine Lease failed');
            return false;
        }
    };

    const AuditOgLeaseChange = async (data: Audit) => {
        let currentPath = window.location.pathname.split('/');
        currentPath.splice(currentPath.length - 3, 3);

        let result = await post(
            `/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/leases/audit`,
            data
        );
        if (response.ok) {
            console.log(result);
            return true;
        } else {
            window.alert('Audit OGLease failed');
            return false;
        }
    };

    return (
        <Dialog title="Confirm Revoke In-hand Status">
            <div style={{ textAlign: 'center', fontSize: '2rem' }} className="mb-2">
                Are you sure want to revoke contract {props.entityName} In-hand status?
            </div>
            <div>
            <input
                name={`UninhandReason`}
                ref={inputRef}
                type={'text'}
                defaultValue={`Reason for revoking In-hand status`}
                readOnly={false}
                style={{ width: '100%' }}
                onKeyPress={handleEdit}
                onClick={clearInputField}
                maxLength={256}
            />
            </div>
            <br/>
            <div style={{ textAlign: 'center' }}>
                <Button text="Confirm" onClick={() => { confirmRevokeInhand(props.entityName);  }} className="mr-2" intent="primary" />
                <Button text="Cancel" onClick={props.cancelRevokeInhand} intent="danger" />
            </div>
        </Dialog>
    );
};

export default RevokeContractInhandDialog;



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/redesign/ConfirmRevokeContractInHandDialog.tsx